/* pg-rvd.js – dymek „Ostatnio oglądane” na karcie produktu (27.09, „DYMEK-1 A”, krok 43.26; makieta 598 T3 wariant A,
   plan `badania/2026-09-27-ostatnio-ogladane-makieta-598.md` §6). Zastępuje część „recently-viewed (v84)” z `pg-product.js` (karuzela na dole karty).

   Historia: localStorage `pg_recently_viewed` – identyfikatory, najnowszy pierwszy, maks. 12 (bez zmian od v84; zapis bez czekania na zgodę –
    D15 z 15.09, B23 a; Polityka prywatności 3.3 – „ostatnio oglądane Produkty” w kategorii „Funkcjonalne”).
   Lista: do 10 innych produktów – TA SAMA sekcja `pg-recently-viewed` pobrana przez wyszukiwarkę po id (Section Rendering API; adres z
   `Shopify.routes.root`, więc na /en po angielsku) – cena, dostępność i strzałka klasy energetycznej zawsze świeże; produktów zdjętych
   ze sprzedaży wyszukiwarka nie zwraca, więc wypadają z historii (tylko gdy odpowiedź ma choć jeden wiersz – błąd sieci niczego nie kasuje).
   Dymek ukryty: bez innych produktów; pod oknem zgód CookieFirst i każdym innym obcym elementem przyklejonym do ekranu w miejscu pigułki
   (sprawdzenie „co leży w tym punkcie” – 27.09 na żywym: okno zgód to `dialog.cookiefirst-root` z nakładką na cały ekran); przy otwartej
   szufladzie, menu, wyszukiwarce, panelu podkategorii i porównaniu (klasy `body` – CSS); przy klawiaturze ekranowej; po „Ukryj do końca wizyty”
   (sessionStorage). Okno listy: komputer – niemodalne nad pigułką (Escape, klik obok); telefon – arkusz modalny (tło, fokus w oknie, Escape
   i „wstecz” zamykają – `history.pushState`). Odnośniki do produktów – w tej samej karcie przeglądarki (B118 f). */
(function () {
  'use strict';
  if (window.__pgRvd) return;
  window.__pgRvd = true;
  /* edytor motywu przeładowuje sekcję w miejscu – dymek (przeniesiony do body) zostawałby podwójnie; działa na sklepie i na podglądzie motywu */
  if (window.Shopify && window.Shopify.designMode) return;

  var KEY = 'pg_recently_viewed';
  var KEY_UKRYJ = 'pg_rvd_ukryte';
  var MAX = 12;
  var SHOW = 10;
  var NAKLADKI = ['scrollLock', 'search-open', 'pg-podmenu-otwarte', 'pg-compare-open'];
  var mqTel = window.matchMedia('(max-width: 767px)');
  var mqDotyk = window.matchMedia('(pointer: coarse)');

  function czytaj() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.map(String).filter(Boolean) : [];
    } catch (e) { return []; }
  }
  function zapisz(lista) {
    try { localStorage.setItem(KEY, JSON.stringify(lista.slice(0, MAX))); } catch (e) {}
  }
  function ukryteNaWizyte() {
    try { return sessionStorage.getItem(KEY_UKRYJ) === '1'; } catch (e) { return false; }
  }

  function init() {
    var root = document.querySelector('[data-pg-recent]');
    if (!root) return;
    var html = document.documentElement;
    var biezacy = String(root.getAttribute('data-product-id') || '');
    var sekcja = root.getAttribute('data-section-id') || '';

    function zapiszBiezacy() {
      if (biezacy) zapisz([biezacy].concat(czytaj().filter(function (id) { return id !== biezacy; })));
    }
    zapiszBiezacy();

    /* animacje wejścia motywu zostawiają transform na blokach karty, a transform zamyka `position: fixed` w przodku –
       jak pasek zakupu (`pg-product.js`) przenosimy dymek do body; pusty kontener sekcji nie ma wysokości */
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var dok = null, pill = null, okno = null, tlo = null;
    var otwarte = false, wHistorii = false, ignorujPop = false;
    /* 28.09 (43.26 – kontrola klikana na telefonie): motyw (`global.min.js`, klasa karty produktu – `reloadPage`) przeładowuje stronę przy KAŻDYM
       `popstate`, więc zamknięcie arkusza (krzyżyk, tło, Escape, „wstecz”) przeładowywało całą kartę. Motyw pyta tę funkcję i pomija zdarzenia arkusza. */
    window.pgRvdHistoria = function (e) {
      return ignorujPop || (otwarte && wHistorii) || !!(e && e.state && e.state.pgRvd);
    };
    var kolizja = false, klawiatura = false;
    var trwa = false, ponownie = false, odswiezyc = false;
    var bezPaska = !document.querySelector('[data-sticky-buy-bar]');
    if (bezPaska) root.classList.add('pg-rvd--bez-paska');

    /* ===== dane ===== */
    function wyczysc() {
      if (otwarte) zamknij(false);
      if (planPokaz) { window.clearTimeout(planPokaz); planPokaz = 0; }
      root.hidden = true;
      root.innerHTML = '';
      dok = pill = okno = tlo = null;
      kolizja = false;
      html.classList.remove('pg-rvd-aktywny');
    }
    var planPokaz = 0, probyPokaz = 0, oddajFokus = false;
    function wstaw(nowy) {
      /* odświeżenie listy przy fokusie na pigułce (np. zaraz po zamknięciu okna klawiszem Escape) – fokus wraca na nową pigułkę */
      oddajFokus = oddajFokus || root.contains(document.activeElement);
      root.innerHTML = nowy.innerHTML;
      dok = root.querySelector('.pg-rvd__dok');
      pill = root.querySelector('.pg-rvd__pill');
      okno = root.querySelector('.pg-rvd__okno');
      tlo = root.querySelector('.pg-rvd__tlo');
      if (!dok || !pill || !okno) { oddajFokus = false; wyczysc(); return; }
      probyPokaz = 0;
      pokaz();
    }
    /* arkusz `pg-rvd.css` wczytuje się asynchronicznie – bez niego dymek wisiałby bez stylów pod stopką strony; czekamy na style do ok. 10 s,
       a gdy arkusz się nie wczyta, dymek się nie pokazuje (computed `position` działa także w ukrytym poddrzewie) */
    function pokaz() {
      planPokaz = 0;
      if (!dok) return;
      if (window.getComputedStyle(dok).position !== 'fixed') {
        if (probyPokaz++ < 20) planPokaz = window.setTimeout(pokaz, 500); else oddajFokus = false;
        return;
      }
      root.hidden = false;
      stan();
      if (oddajFokus) { oddajFokus = false; try { pill.focus({ preventScroll: true }); } catch (e) { pill.focus(); } }
    }
    function pobierz() {
      if (!sekcja || ukryteNaWizyte()) { wyczysc(); return; }
      if (otwarte || document.hidden) { odswiezyc = true; return; }
      if (trwa) { ponownie = true; return; }
      var inne = czytaj().filter(function (id) { return id !== biezacy; }).slice(0, SHOW);
      if (!inne.length) { wyczysc(); return; }
      trwa = true;
      var baza = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var adres = baza + 'search?type=product&section_id=' + encodeURIComponent(sekcja) +
        '&q=' + encodeURIComponent(inne.map(function (id) { return 'id:' + id; }).join(' OR '));
      fetch(adres, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (tekst) {
          var nowy = tekst ? new DOMParser().parseFromString(tekst, 'text/html').querySelector('[data-pg-recent]') : null;
          if (!nowy) return; /* błąd odpowiedzi – zostaje to, co było; historii nie ruszamy */
          var wiersze = nowy.querySelectorAll('[data-pg-rvd-id]');
          if (!wiersze.length) { wyczysc(); return; }
          var zwrocone = {};
          for (var i = 0; i < wiersze.length; i++) zwrocone[wiersze[i].getAttribute('data-pg-rvd-id')] = true;
          var hist = czytaj();
          var po = hist.filter(function (id) { return id === biezacy || inne.indexOf(id) === -1 || zwrocone[id]; });
          if (po.length !== hist.length) zapisz(po);
          if (otwarte) { odswiezyc = true; return; }
          wstaw(nowy);
        })
        .catch(function () {})
        .then(function () {
          trwa = false;
          if (ponownie) { ponownie = false; pobierz(); }
        });
    }
    function zOdswiezeniem() {
      if (odswiezyc && !otwarte && !document.hidden) { odswiezyc = false; pobierz(); }
    }

    /* ===== stan: widoczny / ukryty ===== */
    function chceWidoczny() {
      if (!dok || root.hidden) return false;
      if (bezPaska) return root.classList.contains('pg-rvd--przewiniete');
      /* 16.10 (W1): na telefonie i tablecie pasek zakupu stoi od wejścia (pg-product.js), a dymek zostaje jak dotąd – dopiero po
         minięciu głównego przycisku (`pg-stickybar-minal`; na komputerze to samo co `pg-stickybar-visible`). Położenie nad paskiem
         dalej z `pg-stickybar-visible` (pg-rvd.css) – przy minięciu pasek zawsze stoi. */
      return document.body.classList.contains('pg-stickybar-minal');
    }
    function nakladka() {
      for (var i = 0; i < NAKLADKI.length; i++) if (document.body.classList.contains(NAKLADKI[i])) return true;
      return false;
    }
    function stalyObcy(el) {
      for (var n = el; n && n !== document.body && n !== html; n = n.parentElement) {
        if (window.getComputedStyle(n).position === 'fixed') return true;
      }
      return false;
    }
    /* co leży w miejscu pigułki: pierwszy element spoza dymka (elementy z pointer-events: none przeglądarka pomija) – gdy to element
       przyklejony do ekranu (okno zgód, pasek porównania, widżet aplikacji), dymek się chowa; zwykła treść strony – nie */
    function sprawdzKolizje() {
      var r = pill.getBoundingClientRect();
      if (!r.width || !r.height) { kolizja = false; return; }
      var pkt = [[r.left + 12, r.bottom - 12], [r.left + r.width / 2, r.top + r.height / 2], [r.right - 12, r.top + 12]];
      var k = false;
      for (var i = 0; i < pkt.length && !k; i++) {
        var x = pkt[i][0], y = pkt[i][1];
        if (x < 0 || y < 0 || x >= window.innerWidth || y >= window.innerHeight) continue;
        var lista = document.elementsFromPoint(x, y);
        for (var j = 0; j < lista.length; j++) {
          var e = lista[j];
          /* znaczek zaufania Judge.me (`pg-znaczek-zaufania`) sam ustępuje dymkowi – przy `html.pg-rvd-aktywny` znika (976, 02.10; do 976 unosił się nad pigułkę);
             liczony jako przeszkoda chowałby dymek na zawsze (802, próba 30.09: z nim „pg-rvd--ukryty”); na telefonie oba stoją w prawym dolnym rogu */
          if (root.contains(e) || (e.closest && e.closest('.pg-zz'))) continue;
          if (e !== html && e !== document.body) k = stalyObcy(e);
          break;
        }
      }
      kolizja = k;
    }
    function stan() {
      if (!dok) { html.classList.remove('pg-rvd-aktywny'); return; }
      var sesja = ukryteNaWizyte();
      if (otwarte && (sesja || klawiatura || nakladka())) zamknij(false);
      if (!otwarte && chceWidoczny() && !sesja && !klawiatura && !nakladka()) sprawdzKolizje();
      var ukryty = sesja || klawiatura || kolizja;
      root.classList.toggle('pg-rvd--ukryty', ukryty);
      html.classList.toggle('pg-rvd-aktywny', otwarte || (chceWidoczny() && !ukryty && !nakladka()));
    }
    var planStanu = 0;
    function zaplanujStan() {
      if (planStanu) return;
      planStanu = window.requestAnimationFrame(function () { planStanu = 0; stan(); });
    }

    /* strona bez paska zakupu (cena 0, „tylko kontakt”): dymek po przewinięciu o ekran */
    var planPrzew = 0;
    function przewiniecie() {
      planPrzew = 0;
      var p = (window.pageYOffset || document.documentElement.scrollTop || 0) > window.innerHeight;
      if (p !== root.classList.contains('pg-rvd--przewiniete')) { root.classList.toggle('pg-rvd--przewiniete', p); stan(); }
    }
    if (bezPaska) {
      przewiniecie();
      window.addEventListener('scroll', function () { if (!planPrzew) planPrzew = window.requestAnimationFrame(przewiniecie); }, { passive: true });
    }

    document.addEventListener('pg:dok', function (e) { if (e.detail !== 'rvd' && otwarte) zamknij(false); });

    /* ===== okno listy ===== */
    function otworz(zHistorii) {
      if (otwarte || !okno) return;
      otwarte = true;
      /* 41.3 (B193 b): jeden zestaw w rogu – otwarte okno zwija panel porównania (pg-global.js słucha `pg:dok`) */
      document.dispatchEvent(new CustomEvent('pg:dok', { detail: 'rvd' }));
      var tel = mqTel.matches;
      root.classList.add('is-otwarte');
      html.classList.add('pg-rvd-otwarte');
      okno.setAttribute('aria-modal', tel ? 'true' : 'false');
      okno.hidden = false;
      /* lista zawsze od najnowszego – przeglądarka pamięta przewinięcie z poprzedniego otwarcia (28.09) */
      var lista = okno.querySelector('.pg-rvd__l');
      if (lista) lista.scrollTop = 0;
      pill.setAttribute('aria-expanded', 'true');
      if (tel) {
        if (tlo) tlo.hidden = false;
        html.classList.add('pg-rvd-blokada');
        if (zHistorii) wHistorii = true; /* „dalej” wróciło na wpis arkusza – wpis już jest */
        else { try { window.history.pushState({ pgRvd: 1 }, ''); wHistorii = true; } catch (e) { wHistorii = false; } }
      }
      try { okno.focus({ preventScroll: true }); } catch (e) { okno.focus(); }
      stan();
    }
    function zamknij(fokus, zHistorii) {
      if (!otwarte) return;
      otwarte = false;
      root.classList.remove('is-otwarte');
      html.classList.remove('pg-rvd-otwarte');
      html.classList.remove('pg-rvd-blokada');
      if (okno) okno.hidden = true;
      if (tlo) tlo.hidden = true;
      if (pill) pill.setAttribute('aria-expanded', 'false');
      if (wHistorii) {
        wHistorii = false;
        if (!zHistorii) { ignorujPop = true; try { window.history.back(); } catch (e) { ignorujPop = false; } }
      }
      if (fokus && pill) { try { pill.focus({ preventScroll: true }); } catch (e) { pill.focus(); } }
      stan();
      if (odswiezyc) setTimeout(zOdswiezeniem, 0);
    }
    function modalne() {
      return otwarte && okno && okno.getAttribute('aria-modal') === 'true';
    }
    function fokusowalne() {
      return [].slice.call(okno.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (x) { return x.getClientRects().length > 0; });
    }

    /* ===== zdarzenia ===== */
    /* 28.09 (43.26 – test ręczny): „Ukryj” i „Wyczyść historię” zdejmują dymek razem z przyciskiem, na którym stał fokus – fokus spadał na <body>
       (Tab i czytnik ekranu zaczynały od początku strony); oddaję go treści strony – <main id="MainContent" tabindex="-1">, jak „przejdź do treści” – bez przewijania */
    function fokusNaTresc() {
      var m = document.getElementById('MainContent');
      if (!m) return;
      try { m.focus({ preventScroll: true }); } catch (e) { m.focus(); }
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('.pg-rvd__pill')) { e.preventDefault(); if (otwarte) zamknij(true); else otworz(); return; }
      if (t.closest('.pg-rvd__x') || t.closest('.pg-rvd__tlo')) { zamknij(true); return; }
      if (t.closest('.pg-rvd__ukryj')) {
        try { sessionStorage.setItem(KEY_UKRYJ, '1'); } catch (x) {}
        wyczysc();
        fokusNaTresc();
        return;
      }
      if (t.closest('.pg-rvd__wyczysc')) {
        zapisz(biezacy ? [biezacy] : []);
        wyczysc();
        fokusNaTresc();
        return;
      }
      /* telefon: przy otwartym arkuszu w historii leży nasz wpis „okno otwarte” – przejście do produktu go zastępuje, żeby jedno „wstecz” wracało tutaj */
      var a = t.closest('a.pg-rvd__a');
      if (a && wHistorii && !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
        e.preventDefault();
        window.location.replace(a.href);
      }
    });

    document.addEventListener('click', function (e) {
      window.setTimeout(zaplanujStan, 400); /* np. zamknięcie okna zgód – dymek wraca od razu, bez czekania na kontrolę okresową */
      if (!otwarte || modalne()) return;
      var t = e.target;
      if (!(t instanceof Element) || root.contains(t) || t.closest('dialog')) return;
      zamknij(false);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!otwarte) return;
      /* klawisz naciśnięty w otwartym oknie (etykieta energetyczna – `<dialog>` nad listą) należy do tego okna: Escape zamyka najpierw je.
         Nie „jakiekolwiek dialog[open] na stronie” – okno zgód CookieFirst to też `dialog` i może zostać w kodzie strony po decyzji */
      var wOknie = e.target instanceof Element && !!e.target.closest('dialog[open]');
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (wOknie) return;
        e.preventDefault();
        zamknij(true);
        return;
      }
      if (e.key === 'Tab' && modalne()) {
        if (wOknie) return;
        var el = fokusowalne();
        if (!el.length) { e.preventDefault(); return; }
        var akt = document.activeElement;
        if (e.shiftKey && (akt === el[0] || akt === okno || !okno.contains(akt))) { e.preventDefault(); el[el.length - 1].focus(); }
        else if (!e.shiftKey && (akt === el[el.length - 1] || !okno.contains(akt))) { e.preventDefault(); el[0].focus(); }
      }
    });

    /* klawiatura ekranowa (urządzenia dotykowe): pole tekstowe strony ma fokus – dymek się chowa */
    function poleTekstowe(el) {
      if (!el || !(el instanceof Element) || root.contains(el)) return false;
      if (el.isContentEditable) return true;
      var tag = el.tagName;
      if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
      if (tag !== 'INPUT') return false;
      return ['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file', 'image', 'hidden'].indexOf((el.type || '').toLowerCase()) === -1;
    }
    function ustawKlawiature() {
      var k = (mqDotyk.matches || mqTel.matches) && poleTekstowe(document.activeElement);
      if (k !== klawiatura) { klawiatura = k; stan(); }
    }
    document.addEventListener('focusin', function (e) {
      if (modalne() && !okno.contains(e.target) && !(e.target instanceof Element && e.target.closest('dialog'))) {
        try { okno.focus({ preventScroll: true }); } catch (x) { okno.focus(); }
        return;
      }
      ustawKlawiature();
    });
    document.addEventListener('focusout', function () { window.setTimeout(ustawKlawiature, 0); });

    window.addEventListener('popstate', function (e) {
      if (ignorujPop) { ignorujPop = false; return; }
      if (otwarte && wHistorii) { wHistorii = false; zamknij(true, true); return; }
      /* „dalej” na wpis arkusza (po zamknięciu go „wstecz”): arkusz wraca jak każda nakładka z wpisem w historii; gdy nie może (komputer po obróceniu,
         dymek ukryty) – cichy powrót o jeden wpis, żeby następne „wstecz” nie trafiło w przeładowanie motywu */
      if (e.state && e.state.pgRvd && !otwarte) {
        if (okno && mqTel.matches && !root.hidden) otworz(true);
        else { ignorujPop = true; try { window.history.back(); } catch (x) { ignorujPop = false; } }
      }
    });
    /* powrót przyciskiem „wstecz” z pamięci przeglądarki (bfcache): ten produkt znów na początek historii, lista od nowa */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (otwarte) { wHistorii = false; zamknij(false, true); }
      zapiszBiezacy();
      odswiezyc = true;
      zOdswiezeniem();
    });
    /* historia zmieniona w innej karcie – lista od nowa (od razu albo po powrocie do tej karty / zamknięciu okna) */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY || e.key === null) { odswiezyc = true; zOdswiezeniem(); }
    });
    document.addEventListener('visibilitychange', zOdswiezeniem);

    var przyZmianie = function () { if (otwarte) zamknij(false); zaplanujStan(); };
    if (mqTel.addEventListener) mqTel.addEventListener('change', przyZmianie); else if (mqTel.addListener) mqTel.addListener(przyZmianie);
    window.addEventListener('resize', function () { zaplanujStan(); if (bezPaska && !planPrzew) planPrzew = window.requestAnimationFrame(przewiniecie); }, { passive: true });
    /* pasek zakupu, szuflady, menu i porównanie zmieniają klasy body */
    new MutationObserver(zaplanujStan).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    /* elementy przyklejone do ekranu, które pojawiają się bez zmiany klas (okno zgód, widżety aplikacji) – kontrola co 1,5 s, gdy dymek ma być widoczny.
       30.9 P5-c (08.10): NIE w trakcie przewijania – `elementsFromPoint` przy przewijaniu to 12–83 ms pracy co 1,5 s (telefon, procesor 4× – badanie 30.9 §11),
       a przewinięcie nie zmienia tego, co jest przyklejone do ekranu; kontrola wraca 0,6 s po ostatnim przewinięciu (zmiany klas body – jak dotąd od razu) */
    var ostPrzewiniecie = 0;
    window.addEventListener('scroll', function () { ostPrzewiniecie = Date.now(); }, { passive: true });
    window.setInterval(function () { if (!document.hidden && dok && !otwarte && chceWidoczny() && Date.now() - ostPrzewiniecie > 600) stan(); }, 1500);

    /* pobranie listy po `load`, w bezczynności – poza ścieżką krytyczną (jak od v84) */
    var bezczynnie = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 300); };
    if (document.readyState === 'complete') bezczynnie(pobierz, { timeout: 3000 });
    else window.addEventListener('load', function () { bezczynnie(pobierz, { timeout: 3000 }); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
